var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3770_70787)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3770_70787)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3770_70787",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3770_70787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1275 3.55463L0 12.6815V15.0003H2.31875L11.4456 5.87275L9.1275 3.55463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5199 0.479699C14.2124 0.17231 13.7954 -0.000366211 13.3605 -0.000366211C12.9257 -0.000366211 12.5087 0.17231 12.2012 0.479699L10.0137 2.67033L12.3318 4.98845L14.5193 2.80095C14.6719 2.64867 14.793 2.46779 14.8757 2.26866C14.9583 2.06953 15.0009 1.85605 15.0009 1.64045C15.001 1.42486 14.9585 1.21136 14.876 1.01219C14.7935 0.813013 14.6725 0.632063 14.5199 0.479699Z",
    fill: "#CurrentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3770_70787",
    x: 0,
    y: 0,
    width: 15,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3770_70787"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3770_70787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/Pencil-Edit.b1c26c8bb827492ef0b90f9f09024511.svg";
export { ForwardRef as ReactComponent };